import * as React from 'react';

class Region {
    public name: string;
    public url: string;
}

export interface IRegionSelectorProps {
    currentRegion: Region;
    otherRegions: Region[];
}

interface IRegionSelectorState {
    open: boolean;
}

export class RegionSelector extends React.Component<IRegionSelectorProps, IRegionSelectorState> {
    constructor(props: IRegionSelectorProps) {
        super(props);
        this.state = { open: false };
    }

    public render(): JSX.Element {
        const listItems = this.props.otherRegions.map(this.regionItem);

        return (
            <div className="dropdown region-picker">
                <button
                    className="btn dropdown-toggle region-picker__button"
                    type="button"
                    id="regionDropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {this.props.currentRegion.name}
                </button>
                <div className="dropdown-menu region-picker__dropdown" aria-labelledby="regionDropdownMenuButton">
                    {listItems}
                </div>
            </div>
        );
    }

    private regionItem(item: Region, index: number): JSX.Element {
        return (
            <a key={index} className="dropdown-item" href={item.url}>
                {item.name}
            </a>
        );
    }
}
